import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-porque-estudiar-en-uca',
  templateUrl: './porque-estudiar-en-uca.component.html',
  styleUrls: ['./porque-estudiar-en-uca.component.scss']
})
export class PorqueEstudiarEnUcaComponent implements OnInit {
  @Input() htmlEstudiar: string;
  @Input() video: string;
  @Input() title: string;
  @Input() haveButton: boolean;
  @Input() linkButton: boolean;
  isDesktop: boolean;
  @ViewChild('videoPlayer') videoPlayer: any;
  isPlaying: boolean = false;
  apiUrl: any;
  safeVideoUrl: SafeResourceUrl | null = null;
  @ViewChild('imgContainer') imgContainer!: ElementRef;
  @ViewChild('containerBienvenida') containerBienvenida!: ElementRef;
  @ViewChild('containerIzq') containerIzq!: ElementRef;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  @ViewChild('extra') extra!: ElementRef;
  @ViewChild('finish') finish!: ElementRef;

  expanded = false;
  showExpandButton = false;
  constructor(private sanitizer: DomSanitizer, private renderer: Renderer2) {
    this.apiUrl = environment.apiUrl;
  }

  ngOnInit(): void {
    this.safeVideoUrl = this.getSafeYoutubeUrl(this.video);

  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.actualizarEstilos();
  }
  ngAfterViewInit(): void {
    setTimeout(() => this.actualizarEstilos(), 0);
  }

  actualizarEstilos(): void {
    this.isDesktop = window.innerWidth > 768;

    if (!this.imgContainer || !this.containerBienvenida || !this.containerIzq) return;


    this.renderer.removeStyle(this.containerBienvenida.nativeElement, 'align-items');
    this.renderer.removeStyle(this.containerIzq.nativeElement, 'margin-top');

    this.checkHeight();

  }

  togglePlayPause() {
    if (this.videoPlayer.nativeElement.paused || this.videoPlayer.nativeElement.ended) {
      this.videoPlayer.nativeElement.play();
      this.isPlaying = true
    } else {
      this.videoPlayer.nativeElement.pause();
      this.isPlaying = false
    }
  }
  onVideoPlay() {
    this.isPlaying = true;
  }
  onVideoPause() {
    this.isPlaying = false;
  }

  onVideoEnded() {
    this.isPlaying = false;
  }
  redirecc() {

  }
  getSafeYoutubeUrl(url: string): SafeResourceUrl {
    let videoId: string = '';
    if (url) {
      if (url.includes('watch?v=')) {
        videoId = url.split('watch?v=')[1];
      } else if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1];
      }

    }


    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }
  heightInitial = null;
  checkHeight() {
    setTimeout(() => {
      this.isDesktop = window.innerWidth > 768;

      if (this.isDesktop) {
        let extra = this.extra.nativeElement.offsetHeight;
        let alto = this.containerIzq.nativeElement.offsetHeight;
        let altoAumentado = alto * 1.05;

        this.imgContainer.nativeElement.style.maxHeight = `100%`;
        this.imgContainer.nativeElement.style.minHeight = `100%`;
        this.imgContainer.nativeElement.style.height = `100%`;
        let height = (this.isDesktop) ? this.imgContainer.nativeElement.scrollHeight - extra : window.innerHeight * 0.5;
        this.showExpandButton = (height >= altoAumentado - extra);
        if (this.isDesktop) {
          this.imgContainer.nativeElement.style.maxHeight = `${(altoAumentado)}px`;
          this.imgContainer.nativeElement.style.minHeight = `${(altoAumentado)}px`;
          this.imgContainer.nativeElement.style.height = `${(altoAumentado)}px`;
        }
      } else {
        this.showExpandButton = false;
        this.imgContainer.nativeElement.style.maxHeight = `100%`;
        this.imgContainer.nativeElement.style.minHeight = `100%`;
        this.imgContainer.nativeElement.style.height = `100%`;
      }
    }, 0);

  }


  toggleExpand() {
    this.expanded = !this.expanded;
    if (!this.expanded) {
      this.finish.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      let alto = this.containerIzq.nativeElement.offsetHeight;
      let altoAumentado = alto * 1.05;
      this.imgContainer.nativeElement.style.maxHeight = `${altoAumentado}px`;
      this.imgContainer.nativeElement.style.minHeight = `${altoAumentado}px`;
      this.imgContainer.nativeElement.style.height = `${altoAumentado}px`;
      this.containerIzq.nativeElement.style.marginTop = "auto";

    } else {
      this.imgContainer.nativeElement.style.maxHeight = `100%`;
      this.imgContainer.nativeElement.style.minHeight = `100%`;
      this.imgContainer.nativeElement.style.height = `100%`;
      this.containerIzq.nativeElement.style.marginTop = "2%";
    }
  }
}
